import { Component,  ViewChild, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import {  MatTableDataSource } from '@angular/material/table';
import { Constants } from 'src/app/shared/constants';
import { NotificationService } from '../services/notification-service';

@Component({
    selector: 'app-clindx-form-table',
    templateUrl: './clindx-form-table.component.html',
    styleUrls: ['./clindx-form-table.component.scss'],
    standalone: false
})
export class ClindxFormTableComponent implements AfterViewInit {
  @Input() config: any;
  @Output() paginationChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedIndex: EventEmitter<any> = new EventEmitter<any>();
  @Output() rowDeleted: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  paginatorList: HTMLCollectionOf<Element>;
  idx: number;
  displayedColumns: string[];
  matDataSource = new MatTableDataSource<any>();
  isLoading = true;
  pageNumber: number;
  VOForm: UntypedFormGroup;
  isEditableNew: boolean;
  pageIndex = 0;
  pageSize = Constants.PAGINATION_PAGE_SIZE;
  pageSizeOptions: number[] = Constants.PAGINATION_PAGE_SIZE_OPTIONS;
  editOpen: boolean;
  constructor(private snackbarService: NotificationService) { }

  ngAfterViewInit() {
    console.log(this.config.noDuplicates);
    const control = this.config.formGroup.get(this.config.formArrayName) as UntypedFormArray;
    this.matDataSource = new MatTableDataSource(control.controls);
    this.displayedColumns = this.config.columnList.map((col) => col.columnName);
    this.paginatorList = document.getElementsByClassName('mat-paginator-range-label');
    this.initialize(control);
    this.paginator.page.subscribe(() => {
      this.onPaginateChange(this.paginator, this.paginatorList);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.matDataSource.filter = filterValue.trim().toLowerCase();
  }

  edit(formElement, i) {
    this.editOpen = true;
    formElement.get(this.config.formArrayName).at(i).get('isEditable').patchValue(false);
    this.selectedIndex.emit(i);
  }

  save(formElement, i) {
    formElement.get(this.config.formArrayName).at(i).get('isEditable').patchValue(true);
    this.editOpen = false;
    this.selectedIndex.emit(undefined);
  }

  cancel(formElement, i) {
    formElement.get(this.config.formArrayName).at(i).get('isEditable').patchValue(true);
    this.editOpen = false;
    this.selectedIndex.emit(undefined);
  }

  deleteRow(formElement, i) {
    const control = formElement.get(this.config.formArrayName) as UntypedFormArray;
      control.removeAt(i);
      this.rowDeleted.emit(i);
      this.initialize(control);
  }

  onPaginateChange(paginator: MatPaginator, list: HTMLCollectionOf<Element>) {
    setTimeout(() => {
      const from = (paginator.pageSize * paginator.pageIndex) + 1;
      const to = (paginator.length < paginator.pageSize * (paginator.pageIndex + 1))
        ? paginator.length
        : paginator.pageSize * (paginator.pageIndex + 1);

      const toFrom = (paginator.length === 0) ? 0 : `${from} - ${to}`;
      const pageNumber = (paginator.length === 0) ? `0 of 0` : `${paginator.pageIndex + 1} of ${paginator.getNumberOfPages()}`;
      const rows = `Page ${pageNumber} (${toFrom} of ${paginator.length})`;

      if (list.length >= 1) {
        list[0].innerHTML = rows;
      }
    }, 0, paginator.pageIndex);
  }

  setPaginationObject() {
    this.paginationChanged.emit(this.paginator);
  }

  private initialize(control) {
    this.matDataSource = new MatTableDataSource(control.controls);
    const filterPredicate = this.matDataSource.filterPredicate;
    this.matDataSource.filterPredicate = (data: AbstractControl, filter) => {
      return filterPredicate.call(this.matDataSource, data.value, filter);
    };
    this.matDataSource.paginator = this.paginator;
    this.onPaginateChange(this.paginator, this.paginatorList);
  }

}
